import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-zpax-logo",
  templateUrl: "./zpax-logo.component.html",
  styleUrls: ["./zpax-logo.component.scss"],
  standalone: true,
})
export class ZpaxLogoComponent {
  constructor(private router: Router) {}

  navigateHome() {
    this.router.navigate(["home"]);
  }
}
